import { createFileRoute } from "@tanstack/react-router";
import { SupportPage } from "./support";

export const Route = createFileRoute("/es/soporte")({
  head: () => ({
    meta: [
      { title: "Centro de ayuda y soporte — Sellavo" },
      { name: "description", content: "Obtén ayuda con anuncios, pagos, cuentas y compras seguras en Sellavo." },
      { property: "og:title", content: "Centro de ayuda y soporte — Sellavo" },
      { property: "og:description", content: "Obtén ayuda con anuncios, pagos, cuentas y compras seguras en Sellavo." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/soporte" }],
  }),
  component: SupportPage,
});
